export function safeDate(d) {
    if (!d) return null;
    try {
      const date = new Date(d);
      return isNaN(date.getTime()) ? null : date;
    } catch {
      return null;
    }
  }
  
export function formatDate(dateString, format = "YYYY-MM-DD HH:mm:ss") {
    if (!dateString) return "-";
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "-";
      
      const formatMap = {
        "YYYY-MM-DD HH:mm:ss": () => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        "YYYY-MM-DD HH:mm": () => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        "YYYY-MM-DD": () => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        },
        "YYYY-MM": () => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          return `${year}-${month}`;
        },
        "HH:mm:ss": () => {
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${hours}:${minutes}:${seconds}`;
        },
        "MM-DD HH:mm": () => {
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          return `${month}-${day} ${hours}:${minutes}`;
        },
        "YYYY": () => date.getFullYear().toString()
      };

      return formatMap[format] ? formatMap[format]() : date.toLocaleString();
    } catch {
      return "-";
    }
  }
  
export function exportToCSV(data, filename = 'email_data.csv') {
    const headers = ['Email ID', 'Subject', 'Client Name', 'Case Number', 'Priority', 'Category', 'Date', 'Sender'];
    const csvContent = [
      headers.join(','),
      ...data.map(row => [
        row.email_id || '',
        `"${(row.subject || '').replace(/"/g, "'")}"`, 
        row.client_name || 'N/A',
        row.a_number || 'N/A',
        row.prediction_priority_value || 'Normal',
        `"${(row.prediction_category_value || '').replace(/"/g, "'")}"`, 
        row.classification_timestamp ? formatDate(row.classification_timestamp) : '-',
        row.sender_email || 'N/A'
      ].join(','))
    ].join('\n');
  
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
    URL.revokeObjectURL(link.href);
  }
  
// Base URL for MyCase app (configurable via env, fallback to provided test domain)
export const MYCASE_BASE_URL = process.env.REACT_APP_MYCASE_BASE_URL || 'https://immigration-solution-usa-test1.mycase.com';

// Build URL to a specific task
export function buildMyCaseTaskUrl(taskId) {
  if (!taskId) return null;
  return `${MYCASE_BASE_URL}/tasks/${taskId}`;
}

// Build URL to a specific event by id
export function buildMyCaseEventUrl(eventId) {
  if (!eventId) return null;
  return `${MYCASE_BASE_URL}/tasks/events?event_id=${encodeURIComponent(eventId)}`;
}
  